import { lazy } from 'react'
import suspenseComponent from '../../../../../util/suspenseComponent'

// Containers
import SettingsContainer from '../../../../../containers/dashboard/Settings/containers/SettingsContainer'

// Routes
import SettingsMenuRoutes from './routes/SettingsMenuRoutes'


const SettingsRoutes = [
  {
    path: '/:username/settings',
    component: SettingsContainer,
    routes: [
      ...SettingsMenuRoutes
    ]
  }
]

export default SettingsRoutes
